/* eslint-disable unicorn/filename-case -- TODO rename later */
import React from "react";

import { cn } from "~/utils";

import { Tooltip, TooltipContent, TooltipTrigger } from "../Tooltip/Tooltip";

/**
 * @deprecated Use Button component with size="icon" instead.
 * This component has been moved to __deprecated and will be removed in a future version.
 */

type IconButtonVariant = "solid" | "transparent";

type ButtonProps = {
  icon: React.ReactNode;
  label: string;
  dataTestId?: string;
  disabled?: boolean;
  variant?: IconButtonVariant;
  onClick: () => void;
  role?: string;
  tabIndex?: number;
  size?: "sm" | "md" | "lg";
};

const IconButton = ({
  dataTestId,
  disabled = false,
  label,
  icon,
  variant = "solid",
  onClick,
  role,
  tabIndex,
  size = "md",
}: ButtonProps) => {
  const buttonStyle = "flex items-center justify-center rounded cursor-pointer transition-all duration-150";

  const variantStyles = {
    solid:
      "border border-gray-200 text-gray-600 bg-gray-100 enabled:hover:bg-gray-200 enabled:hover:border-gray-300 enabled:hover:text-gray-700",
    transparent: "p-0 rounded-full text-gray-600 bg-transparent enabled:hover:text-gray-700",
  };

  const sizeStyles = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={label}
        className={cn(buttonStyle, variantStyles[variant], sizeStyles[size])}
        data-testid={dataTestId}
        disabled={disabled}
        onClick={onClick}
        role={role}
        tabIndex={tabIndex}
      >
        {icon}
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};

export default IconButton;
